import { Action } from '@ngrx/store';
import * as models from '../../domain/models';

export const LOAD = '[RM Restricted Functions Collection] Load';
export const LOAD_SUCCESS = '[RM Restricted Functions Collection] Load Success';
export const LOAD_FAIL = '[RM Restricted Functions Collection] Load Fail';
export const RESET = '[RM Restricted Functions Collection] Reset';

export const LOAD_USER_RESTRICTIONS = '[RM Restricted Functions Collection] Load User Restrictions';
export const LOAD_USER_RESTRICTIONS_SUCCESS = '[RM Restricted Functions Collection] Load User Restrictions Success';
export const LOAD_USER_RESTRICTIONS_FAIL = '[RM Restricted Functions Collection] Load User Restrictions Fail';

export const LOAD_GROUP_RESTRICTIONS = '[RM Restricted Functions Collection] Load Group Restrictions';
export const LOAD_GROUP_RESTRICTIONS_SUCCESS = '[RM Restricted Functions Collection] Load Group Restrictions Success';
export const LOAD_GROUP_RESTRICTIONS_FAIL = '[RM Restricted Functions Collection] Load Group Restrictions Fail';

export const UPDATE_RESTRICTIONS = '[RM Restricted Functions Collection] Update Restrictions';
export const UPDATE_RESTRICTIONS_SUCCESS = '[RM Restricted Functions Collection] Update Restrictions Success';
export const UPDATE_RESTRICTIONS_FAIL = '[RM Restricted Functions Collection] Update Restrictions Fail';

export class ResetAction implements Action {
  readonly type = RESET;
}

export class LoadAction implements Action {
  readonly type = LOAD;
}

export class LoadSuccessPayload {
  constructor(public items: Array<models.RestrictedFunction>) {}
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;

  constructor(public payload: LoadSuccessPayload) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export class LoadUserRestrictionsPayload {
  constructor(public userId: number) {}
}

export class LoadUserRestrictionsAction implements Action {
  readonly type = LOAD_USER_RESTRICTIONS;

  constructor(public payload: LoadUserRestrictionsPayload) {}
}

export class LoadUserRestrictionsSuccessPayload {
  constructor(public items: Array<models.UserRestrictedFunction>) {}
}

export class LoadUserRestrictionsSuccessAction implements Action {
  readonly type = LOAD_USER_RESTRICTIONS_SUCCESS;

  constructor(public payload: LoadUserRestrictionsSuccessPayload) {}
}

export class LoadUserRestrictionsFailAction implements Action {
  readonly type = LOAD_USER_RESTRICTIONS_FAIL;
}

export class LoadGroupRestrictionsPayload {
  constructor(public groupId: number) {}
}

export class LoadGroupRestrictionsAction implements Action {
  readonly type = LOAD_GROUP_RESTRICTIONS;

  constructor(public payload: LoadGroupRestrictionsPayload) {}
}

export class LoadGroupRestrictionsSuccessPayload {
  constructor(public items: Array<models.UserRestrictedFunction>) {}
}

export class LoadGroupRestrictionsSuccessAction implements Action {
  readonly type = LOAD_GROUP_RESTRICTIONS_SUCCESS;

  constructor(public payload: LoadGroupRestrictionsSuccessPayload) {}
}

export class LoadGroupRestrictionsFailAction implements Action {
  readonly type = LOAD_GROUP_RESTRICTIONS_FAIL;
}

export class UpdateRestrictionsPayload {
  constructor(
    public userId: number,
    public groupId: number,
    public restrictedFunctions: Array<models.UserRestrictedFunction>
  ) {}
}

export class UpdateRestrictionsAction implements Action {
  readonly type = UPDATE_RESTRICTIONS;

  constructor(public payload: UpdateRestrictionsPayload) {}
}

export class UpdateRestrictionsSuccessAction implements Action {
  readonly type = UPDATE_RESTRICTIONS_SUCCESS;
}

export class UpdateRestrictionsFailAction implements Action {
  readonly type = UPDATE_RESTRICTIONS_FAIL;
}

export type Actions =
  | ResetAction
  | LoadAction
  | LoadSuccessAction
  | LoadFailAction
  | LoadUserRestrictionsAction
  | LoadUserRestrictionsSuccessAction
  | LoadUserRestrictionsFailAction
  | LoadGroupRestrictionsAction
  | LoadGroupRestrictionsSuccessAction
  | LoadGroupRestrictionsFailAction
  | UpdateRestrictionsAction
  | UpdateRestrictionsSuccessAction
  | UpdateRestrictionsFailAction;
